export default __webpack_public_path__ + "static/media/promotion-bottom.7c542850.png";